export const AI_PRO_ADVISOR = {
  //** AiProAssistantSocketMessageType */
  SET_STATUS: 'set_status',
  APPEND_MESSAGES: 'append_messages',
  APPEND_MESSAGE_DELTA: 'append_message_delta',
  CLEAR_MESSAGE: 'clear_message',
  APPEND_ATTACHMENTS: 'append_attachments',
  SET_TASK_UPDATES: 'set_task_updates',
  TOOL_USE: 'tool_use',
  //
  CONFIGURE: 'configure',
  DISPLAY_ACTION: 'display_action',

  //** display action types */
  COLLECT_ESG_PREFERENCES: 'collect_esg_preferences',
  ANALYZE_PORTFOLIO_FROM_WEIGHTS: 'fineco_analyze_portfolio_from_weights',
  SET_PRODUCTS: 'fineco_set_products',
  SEND_EMAIL: 'gmail_send_email_v2',
  //
  //** AiProAdvisorThreadStatusModel */
  IN_PROGRESS: 'in_progress',
  EXPIRED: 'expired',
  FAILED: 'failed',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',

  //** status update */
  VINCOLI_IN_PROGRESS: 'vincoli_in_progress',
  VINCOLI_COMPLETED: 'vincoli_completed',
  CREATE_PORTFOLIO_IN_PROGRESS: 'create_portfolio_in_progress',
  CREATE_PORTFOLIO_COMPLETED: 'create_portfolio_completed',
  CREATE_PORTFOLIO_COMMENT_IN_PROGRESS: 'create_portfolio_comment_in_progress',
  CREATE_PORTFOLIO_COMMENT_COMPLETED: 'create_portfolio_comment_completed',
};
